import React from 'react';
import { useNavigate } from 'react-router-dom';

const Partner: React.FC = () => {
  const navigate = useNavigate();

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#contact');
      setTimeout(() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }), 150);
    }
  };

  return (
    <section className="partner">
      <div className="container">
        <div className="partner-inner">
          <div className="partner-glow" />
          <div className="partner-content">
            <span className="section-label" style={{ justifyContent: 'center', marginBottom: 20 }}>
              Partner with Us
            </span>
            <h2 className="partner-heading">
              Ready to build something<br />
              <span className="gt">that actually works?</span>
            </h2>
            <p className="partner-sub">
              We work with founders, product teams, and operations leads who are serious about getting things done.
              If you have a real problem, we'd like to hear about it.
            </p>
            <div className="partner-actions">
              <button className="btn btn-primary partner-btn" onClick={scrollToContact}>
                Start a Conversation
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </button>
              <a href="mailto:team@slatewing.com" className="btn btn-ghost">
                team@slatewing.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partner;
